
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class AccountGroupGrid extends Serenity.EntityGrid<AccountGroupRow, any> {
        protected getColumnsKey() { return 'OMS.AccountGroup'; }
        protected getDialogType() { return AccountGroupDialog; }
        protected getIdProperty() { return AccountGroupRow.idProperty; }
        protected getInsertPermission() { return AccountGroupRow.insertPermission; }
        protected getLocalTextPrefix() { return AccountGroupRow.localTextPrefix; }
        protected getService() { return AccountGroupService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}